import * as actions from "./actions";

const initialState = {
	loading: false,
	errors: {},
};

const reducer = function (state = initialState, { type, payload }) {
	switch (type) {
		case actions.CREATE_SUBSCRIPTION: {
			return {
				...state,
				loading: true,
				errors: initialState.errors,
			};
		}
		case actions.CREATE_SUBSCRIPTION_SUCCESS: {
			return {
				...initialState,
			};
		}
		case actions.CREATE_SUBSCRIPTION_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload,
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload,
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState,
			};
		default: {
			return state;
		}
	}
};

export default reducer;
